const Logo = ({ brandLogoUrl, brandName }) => {

  const logoUrl = brandLogoUrl;
  const alternateText = brandName || '';

  return (
    <figure className="primary-brand-logo">
      <img src={logoUrl} alt={alternateText} />
    </figure>
  );
};

export default Logo;